const extractSrcFromIframe = (iframeString) => {
  // Use regex to find the value inside the src attribute
  const srcMatch = iframeString.match(/src="([^"]+)"/);
  return srcMatch ? srcMatch[1] : null;
};

export default extractSrcFromIframe;
